import { apiFetch } from '../../lib/api';
import {
  type UpdateWonCarDto,
  type WonCarResponse,
  type WonCarWithDetails,
  type WonCarsListResponse,
} from './types';

/**
 * Won-cars feature API — ported from the web RTK Query `wonCarsApi`. Every call
 * hits api-node directly (won-cars module, phase-7-step-1). Endpoints consumed:
 * - GET   /won-cars          → admin sees ALL users' won cars.
 * - PATCH /won-cars/:id      → admin-only edit of financials / delivery status.
 */

/** All won cars with populated bid/car/user (admin scope). */
export async function fetchWonCars(): Promise<WonCarWithDetails[]> {
  const response = await apiFetch<WonCarsListResponse>('won-cars');
  return response.wonCars ?? [];
}

/** Update a won car's financials and/or delivery status (admin only). */
export async function updateWonCar(
  id: string,
  updates: UpdateWonCarDto,
): Promise<WonCarWithDetails> {
  const response = await apiFetch<WonCarResponse>(`won-cars/${id}`, {
    method: 'PATCH',
    body: updates,
  });
  return response.wonCar;
}
